// TODO dispatch action from all modules (use modules directory to load stores)
import Vue from "vue";
import Vuex from "vuex";
import { cloneDeep, assign, forEach } from 'lodash';
import { Tabs, Tab } from "vue-tabs-component";
import appStore from '@/stores/modules/app.store';
import headerStore from '@/stores/modules/header.store';
import account from "./modules/account.store";
import category from "./modules/category.store";
import items from "./modules/item.store";
import itemOptions from "./modules/item.option.store";
import itemOptionExceptions from "./modules/item.option.exception.store";
import bundle from './modules/bundle.store';
import cart from "./modules/cart.store";
import cartOptions from "./modules/cart.option.store";
import order from './modules/order.store';
import recentOrders from "./modules/recent.orders.store";
import tracker from './modules/tracker.store';
import accountCheckout from "./modules/account.checkout.store";
import location from "./modules/location.store";
import upsell from './modules/upsell.store';
import discount from './modules/discount.store';
import franchisor from './modules/franchisor.store';
import layout from './modules/layout.store';
Vue.use(Vuex);
Vue.component("tabs", Tabs);
Vue.component("tab", Tab);
var initialState = {
    headerStore: cloneDeep(headerStore.state),
    category: cloneDeep(category.state),
    items: cloneDeep(items.state),
    itemOptions: cloneDeep(itemOptions.state),
    itemOptionExceptions: cloneDeep(itemOptionExceptions.state),
    bundle: cloneDeep(bundle.state),
    cart: cloneDeep(cart.state),
    cartOptions: cloneDeep(cartOptions.state),
    order: cloneDeep(order.state),
    recentOrders: cloneDeep(recentOrders.state),
    tracker: cloneDeep(tracker.state),
    accountCheckout: cloneDeep(accountCheckout.state),
    location: cloneDeep(location.state),
    upsell: cloneDeep(upsell.state),
    discount: cloneDeep(discount.state),
    franchisor: cloneDeep(franchisor.state),
    layout: cloneDeep(layout.state),
};
Object.freeze(initialState);
var store = new Vuex.Store({
    modules: {
        appStore: appStore,
        headerStore: headerStore,
        account: account,
        category: category,
        items: items,
        itemOptions: itemOptions,
        itemOptionExceptions: itemOptionExceptions,
        bundle: bundle,
        cart: cart,
        cartOptions: cartOptions,
        order: order,
        recentOrders: recentOrders,
        tracker: tracker,
        accountCheckout: accountCheckout,
        location: location,
        upsell: upsell,
        discount: discount,
        franchisor: franchisor,
        layout: layout,
    },
    mutations: {
        reset: function (state) {
            var keys = Object.keys(state);
            forEach(keys, function (key) {
                assign(state[key], initialState[key]);
            });
        },
    },
});
export default store;



//////////////////
// WEBPACK FOOTER
// ./src/stores/index.ts
// module id = null
// module chunks = 